import cls from 'clsx';
import React, { useState } from 'react';
import SidebarListItem from './sidebarListItem';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useStyles } from './styles';
import { withRouter } from 'react-router-dom';
import { ClassNameMap } from '@material-ui/styles';
import { sidebarItem } from './sidebarModel';
import CustomPopover from '../CustomPopover';

const SidebarListItemGroup = (props: any) => {
   const { text, items, onClick } = props;
   const sidebarGroupRoutes: Array<string> = React.useMemo(() => [], []);
   const [isActiveGroup, setActiveGroup] = useState(sidebarGroupRoutes.includes(props.location.pathname));
   const [open, setOpen] = useState(sidebarGroupRoutes.includes(props.location.pathname));
   const classes: ClassNameMap = useStyles();

   const itemsList = items.map((item: sidebarItem, index: number) => {
      if (!item.show) {
         return;
      }

      sidebarGroupRoutes.push(item.route);
      return (
         <SidebarListItem
            className={classes.childListItems}
            nested
            key={index}
            onClick={onClick}
            route={item.route}
            text={item.text}
            icon={item.icon}
         />
      );
   });

   // when the sidebar group is opened
   // when an item from the list is matching the current route

   React.useEffect(() => {
      setActiveGroup(sidebarGroupRoutes.includes(props.location.pathname));
   }, [props.location.pathname, sidebarGroupRoutes]);

   const coloredText = cls({
      [classes.sidebarActiveColor]: isActiveGroup === true,
   });

   const handleClick = () => {
      setOpen(!open);
   };

   return (
      <>
         <ListItem
            className={isActiveGroup ? classes.sidebarListItemActive : classes.sidebarListItem}
            button
            onClick={handleClick}
         >
            {props.variant && !props.open ? (
               <CustomPopover
                  actionElem={
                     <ListItemIcon className={isActiveGroup ? classes.sidebarListItemIcon : classes.sidebarIcon}>
                        <span className={props.icon} />
                     </ListItemIcon>
                  }
                  content={<>{itemsList}</>}
               />
            ) : (
               <ListItemIcon className={isActiveGroup ? classes.sidebarListItemIcon : classes.sidebarIcon}>
                  <span className={props.icon} />
               </ListItemIcon>
            )}
            <ListItemText classes={{ root: coloredText }} primary={text} />
            {open ? (
               <ExpandLess color={isActiveGroup ? 'secondary' : 'primary'} />
            ) : (
               <ExpandMore color={isActiveGroup ? 'secondary' : 'primary'} />
            )}
         </ListItem>
         {props.open && (
            <Collapse in={open} timeout="auto" unmountOnExit>
               <List component="div" disablePadding>
                  {itemsList}
               </List>
            </Collapse>
         )}
      </>
   );
};

export default withRouter(SidebarListItemGroup);
